export default __webpack_public_path__ + "static/media/green_tick.062e38c0.svg";